export enum RenderMethods {
  text = 'text',
  template = 'template',
  component = 'component',
}
